import AtomicAccountSettings from "../../../../src/courses/partials/atomic/account-settings";
import * as React from 'react';
export default {
  AtomicAccountSettings,
  React
};